import { render, staticRenderFns } from "./CurriculumReadNECYearly.vue?vue&type=template&id=59bdfb36&scoped=true&"
import script from "./CurriculumReadNECYearly.vue?vue&type=script&lang=ts&"
export * from "./CurriculumReadNECYearly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bdfb36",
  null
  
)

export default component.exports